/*
 * Converts a Rekognition face bounding box into a CSS object-position value, so
 * an avatar with object-fit: cover centres on the face instead of the middle of
 * the photo. Pure — no module-level mutable state.
 *
 * Box fields are fractions of image width/height (0..1), as returned by
 * DetectFaces. See docs/superpowers/specs/2026-08-17-face-recognition-design.md
 */

const clampPercent = n => Math.min(100, Math.max(0, n));

export function faceBoxToObjectPosition(faceBox) {
    if (!faceBox) {
        return null;
    }
    const left = Number(faceBox.Left);
    const top = Number(faceBox.Top);
    const width = Number(faceBox.Width);
    const height = Number(faceBox.Height);
    if (![left, top, width, height].every(n => Number.isFinite(n))) {
        return null;
    }
    if (width <= 0 || height <= 0) {
        return null;
    }
    const x = clampPercent(Math.round((left + (width / 2)) * 100));
    const y = clampPercent(Math.round((top + (height / 2)) * 100));
    return `${x}% ${y}%`;
}

export default { faceBoxToObjectPosition };
